export default __webpack_public_path__ + "static/media/peoplestrust.616a0833.png";